import React, {useEffect, useState} from 'react'
import {Button, Modal, ModalHeader, ModalBody, ModalFooter} from 'reactstrap'
import VariantTable from './VariantTable'
import {useSelectedVariantContext} from '../../context/SelectedVariantContext'
import {actionUpdatePickerVariants} from '../../context/SelectedVariantContext/action'

const AvailableProductVariant = ({isOpen, toggle, attributes}) => {
    const {
        dispatch,
        state: {pickerVariants, variants},
    } = useSelectedVariantContext()
    const [selectedVariants, setSelectedVariants] = useState([])

    const _updateSelectedVariants = () => {
        const selectedVariantIds = selectedVariants.map((v) => v.id)
        dispatch(actionUpdatePickerVariants(selectedVariantIds))
        toggle()
    }

    useEffect(() => {
        const defaultVariantIds = pickerVariants.map((v) => v._id)
        setSelectedVariants(defaultVariantIds)
    }, [pickerVariants])

    return (
        <Modal
            className="AvailableProductVariant"
            isOpen={isOpen}
            toggle={toggle}
            size="lg"
            centered
            backdrop="static"
            style={{
                '--bs-modal-width': `${attributes?.length > 0 ? 500 + attributes.length * 100 : 500}px`,
            }}
        >
            <ModalHeader toggle={toggle}>Product Variants & Pricing</ModalHeader>
            <ModalBody>
                <div className="fs-14 mb-3">
                    <span className="fw-500 text-primary">
                        {selectedVariants.length} of {variants.length}
                    </span>{' '}
                    <span className="text-muted">variants selected</span>
                </div>
                <VariantTable
                    variants={variants}
                    attributes={attributes}
                    onChange={(selected) => {
                        setSelectedVariants(selected)
                    }}
                    defaultSelectedVariants={pickerVariants}
                />
            </ModalBody>
            <ModalFooter>
                <Button color="default" onClick={toggle}>
                    Cancel
                </Button>
                <Button color="primary" disabled={!selectedVariants.length} onClick={_updateSelectedVariants}>
                    Update
                </Button>{' '}
            </ModalFooter>
        </Modal>
    )
}

export default AvailableProductVariant
